import React from "react";

export default function Asterik() {
  return <span className="text-danger fw-bold">*</span>;
}
